import React from "react";
import moment from "moment";
import { DatePicker } from "antd";
import { InlineDiv } from "../../components/layout/Layout";
import { isFunction, DateUtil } from "../../util";

const DEFAULT_FORMAT = "DD MMM YYYY";

const { RangePicker } = DatePicker;

export const DateRangePicker = ({
	maxWidth = 300, 
	value, 
	format = DEFAULT_FORMAT, 
	onChange
})=>(<RangePicker 
	style={{maxWidth}} 
	value={value}
	format={format}
	onChange={onChange}
/>);

const DatePickerCompare = ({
	displayFormat   = DEFAULT_FORMAT,
	headDate        = DateUtil.getCurrentMonthDateRange(),
	tailDate        = DateUtil.getCurrentMonthDateRange(),
	showTail        = true,
	maxWidth        = 300,
	onHeadDateChange = (momentDates)=>{
		console.log("onHeadDateChange: ",momentDates);
	},
	onTailDateChange = (momentDates)=>{
		console.log("onTailDateChange: ",momentDates);
	}
})=>(
	<InlineDiv style={{alignItems:"center"}}>
		<DateRangePicker key="head" maxWidth={maxWidth} 
			value={headDate} format={displayFormat} 
			onChange={(dates)=>{
				if(isFunction(onHeadDateChange)){
					if(dates.length > 0){
						DateUtil.toStartEndOfDate(dates[0],dates[1]);
					}
					onHeadDateChange(dates);
				}
			}} />
		{showTail ? 
			[<p key={1} style={{paddingLeft:8, paddingRight:8}}> vs </p>, 
				<DateRangePicker key="tail" maxWidth={maxWidth} 
					value={tailDate} format={displayFormat} 
					onChange={(dates)=>{
						if(isFunction(onTailDateChange)){
							if(dates.length > 0){
								DateUtil.toStartEndOfDate(dates[0],dates[1]);
							}
							onTailDateChange(dates);
						}
					}} 
				/>]
			: undefined}
	</InlineDiv>
);
export default DatePickerCompare;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/DatePickerCompare.js